import ForwardCallDisplay from './ForwardCallDisplay'
import ForwardCallForm from './ForwardCallForm.container'
import IconPhoneTalk from 'components/Icons/PhoneTalk'
import IconPhoneForward from 'components/Icons/PhoneForward'
import IconPhoneMissed from 'components/Icons/PhoneMissed'
import IconPhoneHangup from 'components/Icons/PhoneHangup'
import { getNumberType } from '../../utils/getNumberType'
import { get } from 'lodash'

export default {
  id: 'forward_call',
  label: 'Forward Call',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/forward-call',
  icon: IconPhoneForward,
  inputs: [{}],
  outputs: [
    {
      name: 'whisper',
      label: 'Whisper to the callee before the call is connected.',
      icon: IconPhoneTalk,
    },
    {
      name: 'call-complete',
      label: 'If the called party hangs up (call complete).',
      icon: IconPhoneHangup,
    },
    {
      name: 'call-busy-no-answer',
      label:
        "If the called party is busy or does not answer (this can be controlled with 'timeout'). Note, phones with voicemail may not work.",
      icon: IconPhoneMissed,
    },
  ],
  display: ForwardCallDisplay,
  form: ForwardCallForm,
  getPriceId: node => {
    const numberRaw = get(node, 'extras.number')
    // number can be string or string[]
    const number = Array.isArray(numberRaw) ? numberRaw[0] : numberRaw
    const numberType = getNumberType(number || '')
    if (numberType === 'tollFree') {
      return 'makeTollFreeCall'
    } else if (numberType === 'mobile') {
      return 'makeMobileCall'
    } else if (numberType === 'local') {
      return 'makeLocalCall'
    }
  },
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ForwardCall/index.js